<section class="light-green-background">
  @if (customer$ | async; as customer) {
    <p class="subtitle">{{ 'TGA.WelcomeTitle' | translate }} {{ customer.name }}</p>
  }
  <div class="header-container">
    <h1>{{ 'TGA.Title' | translate }}</h1>
    <button mat-icon-button (click)="openInfo()">
      <mat-icon>info_outline</mat-icon>
    </button>
    <app-crop-year-selector />
  </div>
  <app-notifications-container
    [notifications]="notifications()"
    [dismissedNotifications]="dismissedNotifications()"
    [isLoading]="isNotificationsLoading()"
    (notificationDismissed)="onNotificationDismissed($event)"
  />
</section>
<section class="widgets-container">
  <div class="widget-parent widget-parent--insights">
    <app-weather-forecast-widget />
    <app-blight-dashboard-widget />
    <app-bfp-dashboard-widget />
    @if (!isMobile) {
      <app-widget-list class="list" />
    } @else {
      <mat-expansion-panel class="mobile-expansion-panel" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title> {{ 'cropFieldsOverview' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <app-widget-list class="list"></app-widget-list>
      </mat-expansion-panel>
    }
    <app-water-authority-exceedance-widget
      [waterAuthorities]="(waterAuthorityWidgetData$ | async) ?? []"
      [loading]="(loadingWaterAuthorities$ | async) ?? false"
    />
  </div>
</section>
